module.exports = __webpack_public_path__ + "img/bell-blue.c4045ef9.svg";